import { useRevolvingIndex } from '../../../../hooks/useRevolvingIndex';
export function useAutoCompleteKeyboardSupport(items, onSelect, onKeyDown) {
    const { nextIndex, previousIndex, index: selectedIndex, setIndex } = useRevolvingIndex(items.length - 1);
    const handleKeyDown = (e)=>{
        let wasHandled = false;
        switch(e.key){
            case 'ArrowUp':
                previousIndex();
                wasHandled = true;
                break;
            case 'ArrowDown':
                nextIndex();
                wasHandled = true;
                break;
            case 'Home':
                setIndex(0);
                wasHandled = true;
                break;
            case 'End':
                setIndex(items.length - 1);
                wasHandled = true;
                break;
            case 'Enter':
            case 'Tab':
                if (items.length === 0) {
                    return;
                }
                onSelect && onSelect(items[selectedIndex]);
                wasHandled = true;
                break;
            default:
                onKeyDown && onKeyDown(e);
        }
        if (wasHandled) {
            // Prevent any unintended page scrolling
            e.stopPropagation();
            e.preventDefault();
            return true;
        }
        return false;
    };
    return [
        selectedIndex,
        handleKeyDown
    ];
}

//# sourceMappingURL=hooks.js.map